import { render, staticRenderFns } from "./multiselect-createTicket.vue?vue&type=template&id=57c203e4&scoped=true"
import script from "./multiselect-createTicket.vue?vue&type=script&lang=js"
export * from "./multiselect-createTicket.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./multiselect-createTicket.vue?vue&type=style&index=1&id=57c203e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../fe-workerportal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c203e4",
  null
  
)

export default component.exports